export default "__VITE_ASSET__BW1FFH2R__"